<template>
  <div style="max-width:400px">
    <label><small class="text-muted">Standartwert für Nachtragsrückstellungen</small></label>

    <b-input-group prepend="%" :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)">
      <b-input
        type="number"
        v-model.lazy="settingsStore.settings['Nachtragsprozent']"
        style="max-width:80px"
        min="0"
        max="100"
        @change="updateSettings"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      />
    </b-input-group>
    <label class="mt-3"><small class="text-muted">Nachkommastellen</small></label>
    <b-form-checkbox
      id="checkbox-1"
      name="checkbox-1"
      value="true"
      unchecked-value="false"
      v-model="settingsStore.settings['Centbetraege']"
      @change="updateSettings"
      :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
    >
      Centberträge werden ausgewiesen
    </b-form-checkbox>
    <!--
    <label class="mt-3"><small class="text-muted">Kostencontrolling erfolgt</small></label>
    <b-form-group v-slot="{ ariaDescribedby }">
      <b-form-radio
        v-model="settingsStore.settings['ControllingNettoBrutto']"
        :aria-describedby="ariaDescribedby"
        name="some-radios"
        value="N"
        @change="updateSettings"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      >
        Netto
      </b-form-radio>
      <b-form-radio
        v-model="settingsStore.settings['ControllingNettoBrutto']"
        :aria-describedby="ariaDescribedby"
        name="some-radios"
        value="B"
        @change="updateSettings"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      >
        Brutto
      </b-form-radio>
    </b-form-group>-->
    <label class="mt-3"><small class="text-muted">Standartwert für Mehrwertsteuersatz</small></label>

    <b-input-group prepend="%" :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)">
      <b-input
        type="number"
        v-model.lazy="settingsStore.settings['Mehrwertsteuersatz']"
        style="max-width:80px"
        min="0"
        max="100"
        @change="updateSettings"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      />
    </b-input-group>

    <b-form-group class="mt-3">
      <label><small class="text-muted">Mängelhaftungssicherheit (Vorgabewert)</small></label>
      <b-form-select
        v-model="settingsStore.settings['MHSicherheit']"
        @change="updateSettings"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      >
        <b-form-select-option :value="null" disabled>Bitte wählen</b-form-select-option>
        <b-form-select-option value="0">Netto-Abrechnungssumme</b-form-select-option>
        <b-form-select-option value="1">Brutto-Abrechnungssumme</b-form-select-option>
      </b-form-select>
    </b-form-group>

    <b-form-group class="mt-3">
      <label><small class="text-muted">Mängelhaftung - Vorgabewert für %-Satz</small></label>
      <b-input-group prepend="%" :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)">
        <b-input
          type="number"
          v-model.lazy="settingsStore.settings['MHProzent']"
          style="max-width:80px"
          min="0"
          max="100"
          @change="updateSettings"
          :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
        />
      </b-input-group>
    </b-form-group>
  </div>
</template>

<script>
import settingsStore from '@/store/Settings';
import projectService from '@/service/ProjectsService';
import AppState from '@/store/App.js';
export default {
  data() {
    return {
      settingsStore
    };
  },
  methods: {
    updateSettings() {
      projectService
        .updateProjectSettings(settingsStore.settings)
        .then(() => {
          if (typeof settingsStore.settings['Centbetraege'] === 'string') {
            settingsStore.settings['Centbetraege'] = settingsStore.settings['Centbetraege'] == 'true' ? true : false;
          }
          this.$showSuccess(this, 'Einstellungen', 'Einstellungen erfolgreich aktualisiert.');
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data);
          else this.$showError(this, err.toString());
        });
    }
  },
  activated() {
    AppState.isLoading = false;
  }
};
</script>

<style></style>
